import "./src/styles/global.css"
import "./src/css/bootstrap.css"
import "./src/fonts/font-awesome/css/font-awesome.css"
import "./src/css/style.css"
import "./src/css/nivo-lightbox/nivo-lightbox.css"
import "./src/css/nivo-lightbox/default.css" 
// Scroll-reveal animations are opt-in from the client: the hidden starting
// state hangs off this class, so a no-JS visitor (or a crawler that does not
// run scripts) still sees every section fully rendered.
export const onClientEntry = () => {
  document.documentElement.classList.add("has-reveal")
}
